import { render, staticRenderFns } from "./issue-details.vue?vue&type=template&id=f151a312&scoped=true&"
import script from "./issue-details.vue?vue&type=script&lang=js&"
export * from "./issue-details.vue?vue&type=script&lang=js&"
import style0 from "./issue-details.vue?vue&type=style&index=0&id=f151a312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f151a312",
  null
  
)

export default component.exports